/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AddOnboardingPushRequest,
    AddViewedOnboardingPushRequest,
    IdResponse,
    OnboardingPushNotifyRequest,
    UpdateOnboardingPushRequest,
} from '../models';

export interface OnboardingPushApiControllerAddOnboardingPushRequest {
    addOnboardingPushRequest: AddOnboardingPushRequest;
}

export interface OnboardingPushApiControllerAddViewedOnboardingPushRequest {
    storeId: string;
    addViewedOnboardingPushRequest: AddViewedOnboardingPushRequest;
}

export interface OnboardingPushApiControllerDeleteOnboardingPushRequest {
    id: string;
}

export interface OnboardingPushApiControllerDisableRequest {
    id: string;
}

export interface OnboardingPushApiControllerEnableRequest {
    id: string;
}

export interface OnboardingPushApiControllerNotifyRequest {
    id: string;
    onboardingPushNotifyRequest: OnboardingPushNotifyRequest;
}

export interface OnboardingPushApiControllerPublishRequest {
    id: string;
}

export interface OnboardingPushApiControllerUpdateOnboardingPushRequest {
    id: string;
    updateOnboardingPushRequest: UpdateOnboardingPushRequest;
}

/**
 * 
 */
export class OnboardingPushApi extends runtime.BaseAPI {

    /**
     */
    async onboardingPushApiControllerAddOnboardingPushRaw(requestParameters: OnboardingPushApiControllerAddOnboardingPushRequest): Promise<runtime.ApiResponse<IdResponse>> {
        if (requestParameters.addOnboardingPushRequest === null || requestParameters.addOnboardingPushRequest === undefined) {
            throw new runtime.RequiredError('addOnboardingPushRequest','Required parameter requestParameters.addOnboardingPushRequest was null or undefined when calling onboardingPushApiControllerAddOnboardingPush.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/onboarding-pushes`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.addOnboardingPushRequest,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async onboardingPushApiControllerAddOnboardingPush(requestParameters: OnboardingPushApiControllerAddOnboardingPushRequest): Promise<IdResponse> {
        const response = await this.onboardingPushApiControllerAddOnboardingPushRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async onboardingPushApiControllerAddViewedOnboardingPushRaw(requestParameters: OnboardingPushApiControllerAddViewedOnboardingPushRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling onboardingPushApiControllerAddViewedOnboardingPush.');
        }

        if (requestParameters.addViewedOnboardingPushRequest === null || requestParameters.addViewedOnboardingPushRequest === undefined) {
            throw new runtime.RequiredError('addViewedOnboardingPushRequest','Required parameter requestParameters.addViewedOnboardingPushRequest was null or undefined when calling onboardingPushApiControllerAddViewedOnboardingPush.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/viewed-onboarding-pushes`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.addViewedOnboardingPushRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async onboardingPushApiControllerAddViewedOnboardingPush(requestParameters: OnboardingPushApiControllerAddViewedOnboardingPushRequest): Promise<void> {
        await this.onboardingPushApiControllerAddViewedOnboardingPushRaw(requestParameters);
    }

    /**
     */
    async onboardingPushApiControllerDeleteOnboardingPushRaw(requestParameters: OnboardingPushApiControllerDeleteOnboardingPushRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling onboardingPushApiControllerDeleteOnboardingPush.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/onboarding-pushes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async onboardingPushApiControllerDeleteOnboardingPush(requestParameters: OnboardingPushApiControllerDeleteOnboardingPushRequest): Promise<void> {
        await this.onboardingPushApiControllerDeleteOnboardingPushRaw(requestParameters);
    }

    /**
     */
    async onboardingPushApiControllerDisableRaw(requestParameters: OnboardingPushApiControllerDisableRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling onboardingPushApiControllerDisable.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/onboarding-pushes/{id}:disable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async onboardingPushApiControllerDisable(requestParameters: OnboardingPushApiControllerDisableRequest): Promise<void> {
        await this.onboardingPushApiControllerDisableRaw(requestParameters);
    }

    /**
     */
    async onboardingPushApiControllerEnableRaw(requestParameters: OnboardingPushApiControllerEnableRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling onboardingPushApiControllerEnable.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/onboarding-pushes/{id}:enable`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async onboardingPushApiControllerEnable(requestParameters: OnboardingPushApiControllerEnableRequest): Promise<void> {
        await this.onboardingPushApiControllerEnableRaw(requestParameters);
    }

    /**
     */
    async onboardingPushApiControllerNotifyRaw(requestParameters: OnboardingPushApiControllerNotifyRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling onboardingPushApiControllerNotify.');
        }

        if (requestParameters.onboardingPushNotifyRequest === null || requestParameters.onboardingPushNotifyRequest === undefined) {
            throw new runtime.RequiredError('onboardingPushNotifyRequest','Required parameter requestParameters.onboardingPushNotifyRequest was null or undefined when calling onboardingPushApiControllerNotify.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/onboarding-pushes/{id}:notify`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.onboardingPushNotifyRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async onboardingPushApiControllerNotify(requestParameters: OnboardingPushApiControllerNotifyRequest): Promise<void> {
        await this.onboardingPushApiControllerNotifyRaw(requestParameters);
    }

    /**
     */
    async onboardingPushApiControllerPublishRaw(requestParameters: OnboardingPushApiControllerPublishRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling onboardingPushApiControllerPublish.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/onboarding-pushes/{id}:publish`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async onboardingPushApiControllerPublish(requestParameters: OnboardingPushApiControllerPublishRequest): Promise<void> {
        await this.onboardingPushApiControllerPublishRaw(requestParameters);
    }

    /**
     */
    async onboardingPushApiControllerUpdateOnboardingPushRaw(requestParameters: OnboardingPushApiControllerUpdateOnboardingPushRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling onboardingPushApiControllerUpdateOnboardingPush.');
        }

        if (requestParameters.updateOnboardingPushRequest === null || requestParameters.updateOnboardingPushRequest === undefined) {
            throw new runtime.RequiredError('updateOnboardingPushRequest','Required parameter requestParameters.updateOnboardingPushRequest was null or undefined when calling onboardingPushApiControllerUpdateOnboardingPush.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/onboarding-pushes/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.updateOnboardingPushRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async onboardingPushApiControllerUpdateOnboardingPush(requestParameters: OnboardingPushApiControllerUpdateOnboardingPushRequest): Promise<void> {
        await this.onboardingPushApiControllerUpdateOnboardingPushRaw(requestParameters);
    }

}
